export default function SettingsView() {
  return (
    <div className="settings-view">
      <h1>Settings</h1>

      <section className="card">
        <h2>Access</h2>
        <p className="muted">
          This portal is private to Dave and Rich, enforced at the database level. Reminders
          show up right here on the Dashboard and Calendar — there's no Google Calendar sync set
          up for this app yet. Ask if you want that added; the household app has the exact
          recipe already proven.
        </p>
      </section>
    </div>
  );
}
